<div class="position-relative" >
  <h1 class="h5 mb-4 font-weight-bold" style="display: flex; justify-content:center">Descargar reporte</h1>
  <p class="close-icon" (click)="onClose()">&times;</p>
  <p class="h6 font-weight-bold">Captura tu correo electrónico</p>
  
  <form mat-dialog-content [formGroup]="formReport" (ngSubmit)="send(onSendReport)">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="validate-custom">
          <mat-label>Ingresa tu correo</mat-label>
          <input
            id="correo"
            name="correo"
            matInput
            formControlName="correo"
            maxlength="49"
            [formControl]="formReport.get('correo')"
            (input)="checkRegex($event.target.value)"
          />
        </mat-form-field>
      </div>
      <div class="col-12">
        <p class="mat-error-p" *ngIf="hasError || (formReport.get('correo').invalid && formReport.get('correo').value!== '')">
          Correo inválido
        </p>
      </div>
      <div class="col-12 d-flex justify-content-center" style="padding-top: 15px" >
        <p style="padding: 5px 10px 0 0; color: red">{{error}}</p>
        <ng-template
          [ngIf]="formReport.get('correo').invalid || hasError"
          [ngIfElse]="btnDisabled"
        >
          <button
            type="submit"
            class="btn btn-warning font-weight-bold"
            disabled
          >
            Enviar
          </button>
        </ng-template>
        <ng-template #btnDisabled>
          <button type="submit" class="btn btn-warning font-weight-bold">
            Enviar
          </button>
        </ng-template>
      </div>
    </div>
  </form>
</div>

<!-- MODAL CONFIRMACION REPORTE ENVIADO -->
<ng-template #onSendReport let-modal>
  <div class="card-alert">
    <!-- Imagen -->
    <div class="col-md-4 offset-md-4 mt-4 confirmation">
      <img class="" src="https://s3.amazonaws.com/dev.structure.files/assets/creado.png"/>
    </div>
    <div class="col-md-8 offset-md-2 text-center">
      <h4 class="card-alert-header alert-title mt-3"> ¡Tu reporte ha sido enviado con éxito! </h4>
    </div>
    <div class="modal-footer mt-3">
      <div class="col-8">
        <button type="button" class="btn form-button" (click)="modal.close('Close click')">Entendido</button>
      </div>
    </div>
  </div>
</ng-template>
